import {
  Package,
  Wrench,
  MessageSquareText,
  Search,
  User,
  Globe,
} from 'lucide-react'
import type { AppIconProps } from './AppIcon'
import { isFeatureEnabled } from '@/config/featureFlags'

type DashboardApp = Omit<AppIconProps, 'key'>

const allApps: DashboardApp[] = [
  {
    title: 'Utlevering',
    icon: Package,
    color: 'emerald',
    to: '/import',
    disabled: !isFeatureEnabled('utlevering'),
  },
  {
    title: 'Service',
    icon: Wrench,
    color: 'orange',
    to: '/verksted',
    disabled: !isFeatureEnabled('verksted'),
  },
  {
    title: 'Ordrelogg',
    icon: MessageSquareText,
    color: 'pink',
    to: '/ordrelogg',
    disabled: !isFeatureEnabled('ordrelogg'),
  },
  {
    title: 'PCK Pocket',
    icon: Search,
    color: 'blue',
    to: '/sok',
    disabled: !isFeatureEnabled('pckPocket'),
  },
  {
    title: 'Min side',
    icon: User,
    color: 'zinc',
    to: '#',
    disabled: true,
  },
  {
    title: 'Intranett',
    icon: Globe,
    color: 'indigo',
    to: '#',
    disabled: true,
  },
]

// Filter out disabled apps entirely, or show them as disabled
export const dashboardApps = allApps
